import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  { path: '/', component: () => import('./views/Paint.vue') },
  { path: '/paint', redirect: '/' },
  { path: '/submit', component: () => import('./views/Submit.vue') },
  { path: '/done', component: () => import('./views/Done.vue') },
  { path: '/:pathMatch(.*)*', component: () => import('./views/NotFound.vue') },
]

export const router = createRouter({
  history: createWebHistory(),
  routes,
})
